// Settings Service
// خدمة الإعدادات

class SettingsService {
  constructor() {
    // No longer using cache or API calls - using hardcoded values
  }

  /**
   * Get all public settings (now returns hardcoded values)
   * @returns {Promise<Object>}
   */
  async getAllSettings() {
    // Return hardcoded settings immediately
    return this.getDefaultSettings();
  }

  /**
   * Get settings by group (now returns hardcoded values)
   * @param {string} group - Settings group (e.g., 'map', 'general')
   * @returns {Promise<Object>}
   */
  async getSettingsByGroup(group) {
    // Return hardcoded settings for the group immediately
    return this.getDefaultSettingsForGroup(group);
  }

  /**
   * Get map configuration settings (now returns hardcoded values)
   * @returns {Promise<Object>}
   */
  async getMapConfig() {
    // Return hardcoded map config immediately
    return this.getDefaultMapConfig();
  }

  /**
   * Get a specific setting by key (now returns hardcoded values)
   * @param {string} key - Setting key
   * @returns {Promise<any>}
   */
  async getSetting(key) {
    // Return hardcoded value immediately
    return this.getDefaultValue(key);
  }

  /**
   * Clear cache (no longer needed but kept for compatibility)
   */
  clearCache() {
    // No-op since we're not using cache anymore
  }

  /**
   * Force refresh all settings (now returns hardcoded values)
   * @returns {Promise<Object>}
   */
  async forceRefresh() {
    return await this.getAllSettings();
  }

  /**
   * Force refresh map configuration (now returns hardcoded values)
   * @returns {Promise<Object>}
   */
  async forceRefreshMapConfig() {
    return await this.getMapConfig();
  }

  /**
   * Get default settings (fallback)
   * @returns {Object}
   */
  getDefaultSettings() {
    return {
      map_default_center_lat: 2.4089386,
      map_default_center_lng: 69.2682553,
      map_default_zoom: 5,
      app_name: 'RealMap',
      app_description: 'Real Estate Mapping Platform',
      map_default_style: 'satellite-v9',
      map_min_zoom: 1,
      map_max_zoom: 22,
      map_project_marker_hide_zoom: 12,
      map_landmark_min_zoom: 14,
    };
  }

  /**
   * Get default settings for a specific group
   * @param {string} group
   * @returns {Object}
   */
  getDefaultSettingsForGroup(group) {
    const allDefaults = this.getDefaultSettings();
    const filtered = {};
    
    Object.keys(allDefaults).forEach(key => {
      if ((group === 'map' && key.startsWith('map_')) || 
          (group === 'general' && key.startsWith('app_'))) {
        filtered[key] = allDefaults[key];
      }
    });
    
    return filtered;
  }

  /**
   * Get default map configuration
   * @returns {Object}
   */
  getDefaultMapConfig() {
    return {
      center: [2.4089386,69.2682553], // [lng, lat]
      zoom: 5,
      style: 'satellite-v9',
      minZoom: 1,
      maxZoom: 22,
      projectMarkerHideZoom: 12,
      landmarkMinZoom: 14,
    };
  }

  /**
   * Get default value for a specific key
   * @param {string} key
   * @returns {any}
   */
  getDefaultValue(key) {
    const defaults = this.getDefaultSettings();
    return defaults[key] || null;
  }
}

// Create and export a singleton instance
const settingsService = new SettingsService();
export default settingsService;
